import {
  ProductCard_default,
  clsx_default,
  observer,
  withController
} from "./chunk--chunk-65SBUQCI.vbt.js";
import {
  _,
  init_preact_module
} from "./chunk--chunk-WOOXM6XY.vbt.js";

// src/js/searchspring/Recommendation/index.jsx
init_preact_module();

// src/js/searchspring/shared/SuggestedTerms.jsx
init_preact_module();
var SuggestedTerms = (props) => {
  return /* @__PURE__ */ _("div", { class: "flex flex-col lg:flex-row lg:items-center w-full max-w-screen justify-center gap-4 border-b border-gray-lightest py-6" }, /* @__PURE__ */ _("h2", { class: "font-primary text-[12px] lg:text-[14px] tracking-[1px] ml-[20px] uppercase" }, props.title), /* @__PURE__ */ _("ul", { class: "flex flex-nowrap items-center gap-4 overflow-x-scroll no-scrollbar pl-[30px] pr-[20px] lg:px-0" }, props.terms && props.terms.map((term) => {
    const searchQuery = window.location.origin + "/search?q=" + term.value;
    return /* @__PURE__ */ _("li", { class: "bg-[#F7F7F6] px-3.5 py-2.5 rounded-[10px] lg:overflow-hidden" }, /* @__PURE__ */ _(
      "a",
      {
        href: searchQuery,
        class: "whitespace-nowrap font-primary text-gray-dark text-[14px] font-normal leading-[18px] capitalize",
        onMouseEnter: props.onMouseEnter
      },
      term.value
    ));
  })));
};
var SuggestedTerms_default = SuggestedTerms;

// src/js/searchspring/Recommendation/index.jsx
var Recommendation = withController(
  observer((props) => {
    const {
      controller: {
        store: { results }
      },
      controller
    } = props;
    controller.search();
    return /* @__PURE__ */ _("div", { class: "flex flex-col text-gray-dark max-w-[1440px] mx-auto" }, props.trending?.length > 0 && /* @__PURE__ */ _(SuggestedTerms_default, { title: props.termsTitle, terms: props.trending }), /* @__PURE__ */ _("div", { class: "flex flex-col w-full" }, /* @__PURE__ */ _("h2", { class: "font-primary text-[12px] lg:text-[14px] tracking-[.2px] py-[20px] ml-[20px] lg:ml-[63px] uppercase" }, props.recsTitle), /* @__PURE__ */ _(
      "ul",
      {
        className: clsx_default(
          "flex flex-nowrap gap-4 lg:gap-8 overflow-x-auto scrollbar-thin",
          "scrollbar-thumb-[#B5B5B5] scrollbar-track-[#F7F7F6]",
          "scrollbar-track-rounded-full scrollbar-thumb-rounded-full",
          "pb-4 pr-[16px] pl-[20px] lg:pl-0 ml-0",
          "lg:ml-[63px] scrollbar-w-[7px] scrollbar-h-[7px]"
        )
      },
      results.map((result) => /* @__PURE__ */ _("li", { className: "flex-[0_0_166px] lg:flex-[0_0_275px]" }, /* @__PURE__ */ _(ProductCard_default, { result })))
    )));
  })
);

export {
  SuggestedTerms_default,
  Recommendation
};
